// extracted by css-extract-rspack-plugin
module.exports =  {"root":"Radio__root___lzSvc","selected":"Radio__selected___SbkeJ","radio":"Radio__radio___f9Qxt"};